/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import { setSelectedNumberOfDays } from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import AMOUNT_OF_DAYS from 'constants/amountOfDays';

// Styles
import useStyles from './amountOfDaysFilter.styles';

const AmountOfDaysFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedNumberOfDays = useSelector(
    (state: ApplicationState) => state.reports.numberOfDays,
  );

  const handleNumberOfDays = (numDays: number) => {
    dispatch(
      setSelectedNumberOfDays({
        numberOfDays: numDays,
      }),
    );
  };

  return (
    <List dense>
      {Object.values(AMOUNT_OF_DAYS.STATUS).map((item) => (
        <ListItem key={item.LABEL} button>
          <ListItemText
            id={item.LABEL}
            primary={item.LABEL}
            onClick={() => handleNumberOfDays(item.NUM_DAYS)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              name={item.LABEL}
              color='primary'
              onClick={() => handleNumberOfDays(item.NUM_DAYS)}
              checked={selectedNumberOfDays === item.NUM_DAYS}
              inputProps={{ 'aria-labelledby': item.LABEL }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { AmountOfDaysFilter };
export default AmountOfDaysFilter;
